import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { USE_CASES } from '../data/useCases';

const Clients: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const logos = [
    { name: 'TotalEnergies', slug: 'totalenergies', src: '/images/projects/TotalEnergies.png' },
    { name: 'Stedis',        slug: 'stedis',        src: '/images/projects/Stedis.png' },
    { name: 'SeaUp',         slug: 'seaup',         src: '/images/projects/SeaUp.png' },
    { name: 'Teréga',        slug: 'terega',        src: '/images/projects/Terega.png', scale: 1.6 },
    { name: 'Hydro-Québec',  slug: 'hydroquebec',   src: '/images/projects/Hydro-Québec_logo.svg' },
  ];

  // Exactly 2 copies → translateX(-50%) = one full set → seamless loop
  const track = [...logos, ...logos];

  return (
    <div className="py-16">
      {/* Heading */}
      <div className="text-center mb-12 px-6">
        <h2
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 700,
            fontSize: 'clamp(1.75rem, 3.5vw, 2.5rem)',
            color: 'var(--color-text-primary)',
          }}
        >
          {t('clients.title', 'Nos Clients')}
        </h2>
        <div
          className="mx-auto mt-4"
          style={{ width: 60, height: 3, background: 'var(--gradient-primary)', borderRadius: 2 }}
        />
      </div>

      {/* Marquee track */}
      <div
        className="relative overflow-hidden"
        style={{
          maskImage:
            'linear-gradient(to right, transparent 0%, black 12%, black 88%, transparent 100%)',
          WebkitMaskImage:
            'linear-gradient(to right, transparent 0%, black 12%, black 88%, transparent 100%)',
        }}
      >
        <div
          className="flex animate-marquee"
          style={{ width: 'max-content', gap: '4rem' }}
        >
          {track.map((logo, idx) => (
            <div
              key={idx}
              className="flex-shrink-0 flex items-center justify-center"
              style={{ height: 80, width: 180, cursor: 'pointer' }}
              onClick={() => navigate(USE_CASES.some(u => u.slug === logo.slug) ? `/use-cases/${logo.slug}` : '/use-cases')}
              title={logo.name}
            >
              <img
                src={logo.src}
                alt={`Logo ${logo.name} — client Colibri Technologies`}
                width={160}
                height={56}
                style={{
                  maxHeight: logo.scale ? 56 * logo.scale : 56,
                  maxWidth: logo.scale ? 160 * logo.scale : 160,
                  objectFit: 'contain',
                  filter: 'brightness(0) invert(1)',
                  opacity: 0.55,
                  transition: 'opacity 300ms',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.9')}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.55')}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Clients;
